module.exports = __webpack_public_path__ + "static/media/logo_texto_branco.15c9f091.png";